export const userRole = {
  superAdmin: "superAdmin",
  businessAdmin: "businessAdmin",
  admin: "admin",
  installer: "installer",
  user: "user",
  public: "public",
};
export const userRoleFormate = {
  superAdmin: "Super Admin",
  businessAdmin: "Business Admin",
  admin: "Site Admin",
  installer: "Installer",
  public: "Public User",
  user: "Site User",
};
